import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreConfigService } from '@core/services/config.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth/auth.service';
import Swal from 'sweetalert2';
import { CompanyTypesServiceService } from 'app/modules/main/services/companyTypesService/company-types-service.service';
import { of, Subject } from 'rxjs';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { AlertService } from 'app/shared/services/alert.service';
import { Socket } from 'ngx-socket-io';
import { AdminUserService } from '../../../main/services/adminUserService/admin-user.service';
import { HotelServices } from '../../../hotels/services/hotel/hotel.service';
import { FileUploader } from 'ng2-file-upload';
import * as _ from 'lodash';
import { UploadService } from 'app/shared/services/upload/upload.service';
import { UploadResponse } from 'aws-s3-upload-ash/dist/types';
import { ProviderService } from 'app/modules/provider/services/provider/provider.service';




interface CategoryInterface {// item para mostrar clientes
  id?: number;
  name?: string;
  description?: string;
  select?: boolean;
}

const URL = 'https://your-url.com';


@Component({
  selector: 'app-auth-register-page',
  templateUrl: './auth-register-page.component.html',
  styleUrls: ['./auth-register-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})



export class AuthRegisterPageComponent implements OnInit {

  // Public
  public uploader: FileUploader = new FileUploader({
    url: URL,
    isHTML5: true
  });
  
  public registerForm: FormGroup;
  public loading = false;
  public submitted = false;
  public passwordTextType: boolean;

  public coreConfig: any;
  public returnUrl: string;
  public error = '';

  name: string;
  last_name: string;
  company_name: string;
  nit: string;
  email: string;
  password: string;
  birth_date: string;
  check_subscription: number;
  status: number;
  final_usercol: string;
  categoriesProvider: any;
  selectedCategories=[];
  user: any;
  type: number;
  selectBasic = [
    'Natural',
    'Jurídica'
  ];
  category :CategoryInterface;
  selectsCategories :Array<CategoryInterface> = [];
  usersList: any = [];

  imageError: string;
  isImageSaved: boolean;
  cardImageBase64: string;
  fileSelected: any = null;


  // Private
  private _unsubscribeAll: Subject<any>;

  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private _AuthServiceService: AuthService,
    private _route: ActivatedRoute,
    private alertService: AlertService,
    private _router: Router,
    private socket: Socket,
    private adminUserServices: AdminUserService,
    private _HotelService: HotelServices,
    private uploadService: UploadService,
    private _ProviderService: ProviderService,
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  get f() {
    return this.registerForm.controls;
  }

  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  onSubmit() {
    if(this.selectedCategories.length > 0){
    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    this.alertService.showLoading();
    this._AuthServiceService.providerSignup(this.registerForm.value/*, this.selectedCategories.toString()*/).pipe(takeUntil(this._unsubscribeAll)).subscribe((resp) => {
      this.alertService.showResponse(resp);
      //this.socket.emit('provider_created', resp.data)
      this._router.navigate(['/']);
    });
   }else{
    Swal.fire({
      title: 'Error',
      text: 'Por favor, ingrese todos los campos correctamente',
      icon: 'error',
      confirmButtonText: 'Ok'
    })
   }
  }

  getCategoriesProvider(){
    this._AuthServiceService.Categoriesprovider().subscribe((resp) => {
      const data: any = resp;
      for(let value of data){
        this.category = {
          id: value.id,
          name:  value.name,
          description: value.description,
          select: false
        }
        this.selectsCategories.push(this.category);
      }
    });
  }

  ngOnInit(): void {
    this.registerFormF();
    this.getCategoriesProvider();
    this.getAdmins();
  }

  registerFormF() {

    this.registerForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      logo: ['', [Validators.required]],
      password: ['', Validators.required],
      name: ['', Validators.required],
      last_name: ['', Validators.required],
      company_name: ['', Validators.required],
      nit: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      type_person: ['', Validators.required],
      cedula: ['', Validators.required],
      manager_name: ['', Validators.required],
      manager_last_name: ['', Validators.required],
      city: ['', Validators.required]
     // categories: this._formBuilder.array([], [Validators.required])
    });

  }

  getAdmins() {
    this.adminUserServices.getAllUsersAdmin().subscribe(
      (res: any) => {
        res.forEach(element => {
          if(element.hotel_created == 1){
            this._HotelService.getHotelByAdmin(element.id).subscribe(
              (res: any) => {
                let data = res;
                  this.usersList.push(res);
              }
            )
          }
        });
      }
    )
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  onLogin(loginForm) {
    console.log(loginForm);
  }

  registerRouter(){
    this._router.navigate(['/']);
 }

 onRegister() {

/*   if(this.selectedCategories.length > 0){
 */
 
  let valid = true;

  if (this.type == 2) {
    if (
      this.registerForm.value.name == '' ||
      this.registerForm.value.last_name == '' ||
      this.registerForm.value.cedula == '' ||
      this.registerForm.value.email == '' ||
      this.registerForm.value.password == '' ||
      this.registerForm.value.type_person == '' ||
      this.registerForm.value.confirmPassword == '' ||
     //  this.registerForm.value.categories == '' ||
      this.validPassword() == true
    ) {
      valid = false;
    }
  }
  if (this.type == 1) {
    if (
      this.registerForm.value.company_name == '' ||
      this.registerForm.value.nit == '' ||
      this.registerForm.value.manager_name == '' ||
      this.registerForm.value.email == '' ||
      this.registerForm.value.password == '' ||
      this.registerForm.value.type_person == '' ||
      this.registerForm.value.confirmPassword == '' ||
      this.registerForm.value.manager_name == '' ||
   //    this.registerForm.value.categories == '' ||

      this.validPassword() == true
    ) {
      valid = false;
    }
  }
  if (this.type == undefined) {
    valid = false;
  }

  
  if (valid) {
    if (this.type == 2) {
      this.user = {
      name: this.registerForm.controls['name'].value,
      last_name: this.registerForm.controls['last_name'].value,
      cedula: this.registerForm.controls['cedula'].value,
      email: this.registerForm.controls['email'].value,
      password: this.registerForm.controls['password'].value,
      type_person: this.type-1
    }
    }
    else if (this.type == 1) {
    this.user = {
      company_name: this.registerForm.controls['company_name'].value,
      nit: this.registerForm.controls['nit'].value,
      manager_name: this.registerForm.controls['manager_name'].value,
      manager_last_name: this.registerForm.controls['manager_last_name'].value,
      email: this.registerForm.controls['email'].value,
      password: this.registerForm.controls['password'].value,
      // name: this.registerForm.controls['name'].value,
      // last_name: this.registerForm.controls['last_name'].value,
      type_person: this.type-1,
      // user_type: 'provider',
      city: this.registerForm.controls['city'].value,
     // categories: this.selectedCategories.toString() Hasta organizar la relación YCV
    }
  }

    if (this.type == 2) {
      try {
        this._AuthServiceService.providerSignup(this.user /*,this.selectedCategories.toString()*/).subscribe((create: any) => {
          console.log(create)
          if(create.status == false){
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'El usuario ya está registrado',
            })
          }else{
            Swal.fire({
              icon: 'success',
              title: 'Registro exitoso',
              text: 'Se ha registrado correctamente',
              position: 'top-end',
              showConfirmButton: false,
              timer: 1000
            }).then(() => {
              this._router.navigate(['/']);
            })
            /* this.uploadService.handleSendFile(this.fileSelected).then(
              (res: UploadResponse) => {
                console.log(res)
                if(localStorage.getItem('user_type') == 'admin') {
                  let hotelId = localStorage.getItem('hotel_id');
                }
                if(localStorage.getItem('user_type') == 'provider') {
                  let provider_id = localStorage.getItem('user');
        
                }
                let admin = localStorage.getItem('user_id');
      
                    let userId = create.data.identifiers[0].id
                    console.log('idUser: ',userId)
        
                    this._ProviderService.editUser(userId, res.location).subscribe(
                      (data: any) => {
                        Swal.fire({
                          icon: 'success',
                          title: 'Registro exitoso',
                          text: 'Se ha registrado correctamente',
                          position: 'top-end',
                          showConfirmButton: false,
                          timer: 1000
                        })
                        this.usersList.forEach(element => {
                          let noti = {
                            name: this.user.name,
                            company_name: this.user.company_name,
                            type_person: this.user.type_person,
                            receiver: element.id
                          }
                          //this.socket.emit('provider_created', noti);
                        });
                      }
                    )
                  })
              .catch(err => {
                console.log(err)
              }) */
  
          }
        });
      } catch (error) {
        Swal.fire({
          title: 'Error',
          text: 'No se pudo registrar',
          icon: 'error',
          position: 'top-end',
          confirmButtonText: 'Ok'
  
        })
        
      }
    } 
    
    else if (this.type == 1) {
      try {
        this._AuthServiceService.companySignup(this.user/*, this.selectedCategories.toString()*/).subscribe((createdCompany: any) => {
          console.log(createdCompany)
          this._AuthServiceService.companyUserSignup(this.user, createdCompany).subscribe((createdUserId: any) => {
          console.log(createdCompany)
          if(createdCompany.status == false){
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'El usuario ya está registrado',
            })
          }else{
            Swal.fire({
              icon: 'success',
              title: 'Registro exitoso',
              text: 'Se ha registrado correctamente',
              position: 'top-end',
              showConfirmButton: false,
              timer: 1000
            }).then(() => {
              this._router.navigate(['/']);
            })
            /* this.uploadService.handleSendFile(this.fileSelected).then(
              (res: UploadResponse) => {
                console.log(res)
                if(localStorage.getItem('user_type') == 'admin') {
                  let hotelId = localStorage.getItem('hotel_id');
                }
                if(localStorage.getItem('user_type') == 'provider') {
                  let provider_id = localStorage.getItem('user');
        
                }
                let admin = localStorage.getItem('user_id');
      
                    let userId = createdCompany.data.identifiers[0].id
                    console.log('idUser: ',userId)
        
                    this._ProviderService.editUser(userId, res.location).subscribe(
                      (data: any) => {
                        Swal.fire({
                          icon: 'success',
                          title: 'Registro exitoso',
                          text: 'Se ha registrado correctamente',
                          position: 'top-end',
                          showConfirmButton: false,
                          timer: 1000
                        })
                        this.usersList.forEach(element => {
                          let noti = {
                            name: this.user.name,
                            company_name: this.user.company_name,
                            type_person: this.user.type_person,
                            receiver: element.id
                          }
                          //this.socket.emit('provider_created', noti);
                        });
                      }
                    )
                  }) */
             /*  .catch(err => {
                console.log(err)
              }) */
  
          }
        });
        });
      } catch (error) {
        Swal.fire({
          title: 'Error',
          text: 'No se pudo registrar',
          icon: 'error',
          position: 'top-end',
          confirmButtonText: 'Ok'
  
        })
        
      }
    }

  }else{
    Swal.fire({
      title: 'Error',
      text: 'Por favor, ingrese todos los campos correctamente',
      icon: 'error',
      confirmButtonText: 'Ok'
    })
  }

/* }else{
  Swal.fire({
    title: 'Error',
    text: 'Debe seleccionar por lo menos una categoría',
    icon: 'error',
    confirmButtonText: 'Ok'
  })
} */

}

onChange(event) {
  if (event == 'Natural') {
    this.type = 2;
  }
  if (event == 'Jurídica') { 
    this.type = 1;
  }

}

onCheckboxChange(event:any) {
  if ( this.selectedCategories.indexOf(event.target.value) > -1) {
    let index =  this.selectedCategories.indexOf(event.target.value);
    this.selectedCategories.splice(index, 1);
  }else {
    this.selectedCategories.push(event.target.value);
  } 
  }

  fileChangeEvent(fileInput: any) {
    this.imageError = null;
    console.log('-------------');
    console.log(JSON.stringify(fileInput));
    this.fileSelected = fileInput.target.files[0];
    if (fileInput.target.files && fileInput.target.files[0]) {
      // Size Filter Bytes
      console.log('ingreso');

      const max_size = 20971520;
      const allowed_types = ['image/png', 'image/jpeg'];
      const max_height = 15200;
      const max_width = 25600;

      if (fileInput.target.files[0].size > max_size) {
        this.imageError =
          'Maximum size allowed is ' + max_size / 1000 + 'Mb';

        return false;
      }

      if (!_.includes(allowed_types, fileInput.target.files[0].type)) {
        this.imageError = 'Only Images are allowed ( JPG | PNG )';
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = rs => {
          const img_height = rs.currentTarget['height'];
          const img_width = rs.currentTarget['width'];

          console.log(img_height, img_width);


          if (img_height > max_height && img_width > max_width) {
            this.imageError =
              'Maximum dimentions allowed ' +
              max_height +
              '*' +
              max_width +
              'px';
            return false;
          } else {
            const imgBase64Path = e.target.result;
            this.cardImageBase64 = imgBase64Path;
            this.isImageSaved = true;
            this.registerForm.controls['logo'].setValue("img");
            // Esta es la parte para guardar en S3
            // this.previewImagePath = imgBase64Path;
          }
        };
      };
      reader.readAsDataURL(fileInput.target.files[0]);
    }
  }

  removeImage() {
    this.cardImageBase64 = null;
    this.isImageSaved = false;
  }

 validField(field: string) {
  if (this.type == 2) {
    this.registerForm.controls['company_name'].setValue('');
    this.registerForm.controls['nit'].setValue('');
    this.registerForm.controls['manager_name'].setValue('');
    this.registerForm.controls['manager_last_name'].setValue('');


    return this.registerForm.controls[field].errors &&
      this.registerForm.controls[field].touched;

  } else {
    this.registerForm.controls['name'].setValue('');
    this.registerForm.controls['cedula'].setValue('');
    this.registerForm.controls['last_name'].setValue('');

    return this.registerForm.controls[field].errors &&
      this.registerForm.controls[field].touched;
  }

}

validPassword() {
  return this.registerForm.controls['password'].value !== this.registerForm.controls['confirmPassword'].value &&
    this.registerForm.controls['password'].value !== '';
}
}
